import React, { useCallback } from 'react'
import Button from '../../Elements/buttons/Button'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useWindowBreakPoint } from '../../../hooks/useWindowBreakPoint'
import { theme } from '../../../style/theme'
import { PickupMonitorButtonWrap } from '../index.styled'

const PickupMonitorButtons = React.memo(() => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const location = useLocation()
	const showReturnKasseButton = location.pathname.includes('/cashdesk')
	const showReturnDeliveryButton = location.pathname.includes('/delivery')
	const isTablet = useWindowBreakPoint(theme.point820)

	const navigateToKasse = useCallback(() => {
		navigate('/cashdesk')
	}, [navigate])

	const navigateToDelivery = useCallback(() => {
		navigate('/delivery')
	}, [navigate])

	return (
		<PickupMonitorButtonWrap>
			{showReturnKasseButton &&
				<Button name="navigate-to-cashdesk"
								color="blue" className="icon-auto-width"
								size={!isTablet ? 'small' : ''} icon="navigate-cashdesk"
								text={t('PickupMonitor.kassePanel')}
								onClick={navigateToKasse} />}
			{showReturnDeliveryButton &&
				<Button name="navigate-to-delivery"
								color="blue" className="icon-auto-width"
								size={!isTablet ? 'small' : ''} icon="navigate-delivery"
								text={t('PickupMonitor.deliveryPanel')}
								onClick={navigateToDelivery} />}
		</PickupMonitorButtonWrap>
	)
})

PickupMonitorButtons.displayName = 'PickupMonitorButtons'
export default PickupMonitorButtons
